import { render, staticRenderFns } from "./V2LessonCardSmall.vue?vue&type=template&id=0dc5153f&scoped=true&"
import script from "./V2LessonCardSmall.vue?vue&type=script&lang=js&"
export * from "./V2LessonCardSmall.vue?vue&type=script&lang=js&"
import style0 from "./V2LessonCardSmall.vue?vue&type=style&index=0&id=0dc5153f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc5153f",
  null
  
)

export default component.exports